module.exports = __webpack_public_path__ + "img/sensor_power.b0e098f6.png";